import { Injectable, inject} from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientWrapperService } from '../http/http-client-wrapper.service';
import { Claim, ClaimType } from '../../models/Claim';
import { ApiUrlService } from '../api/api-url.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  private readonly apiUrlService = inject(ApiUrlService);
  private get claimsApiUrl(): string { return this.apiUrlService.buildUrl(`/api/v1/claims`); }

  constructor(private httpClient: HttpClientWrapperService) {}

  submitClaim(claim: Claim, files: File[], profileImage?: File | null): Observable<Claim> {
    const formData: FormData = new FormData();

    Array.from(files).forEach((file: File) => {
      formData.append('files', file);
    });

    const claimBlob: Blob = new Blob([JSON.stringify(claim)], { type: 'application/json' });
    formData.append('claim', claimBlob);

    if (profileImage) {
      formData.append('profileImage', profileImage, profileImage.name);
    }

    return this.httpClient.post<Claim, FormData>(`${this.claimsApiUrl}`, formData);
  }

  getClaimsByUserId(userId: string, claimType?: ClaimType): Observable<Claim[]> {
    const typeParam: string = claimType ? `&claimType=${claimType}` : '';
    return this.httpClient.get<Claim[]>(`${this.claimsApiUrl}?userId=${userId}${typeParam}`);
  }

  getClaim(id: string): Observable<Claim> {
    return this.httpClient.get<Claim>(`${this.claimsApiUrl}/${id}`);
  }
}
